import { createContext, useContext } from 'react'
import type { ReactElement, ReactNode } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAuth } from '../hooks/useAuth'
import type { UseAuthResult } from '../hooks/useAuth'

export interface AuthContextValue extends UseAuthResult {
  apiBaseUrl: string
}

const AuthContext = createContext<AuthContextValue | undefined>(undefined)

interface AuthProviderProps {
  apiBaseUrl: string
  children: ReactNode
}

export function AuthProvider({ apiBaseUrl, children }: AuthProviderProps): ReactElement {
  const navigate = useNavigate()
  const location = useLocation()
  const auth = useAuth({ apiBaseUrl, navigate, location })

  return (
    <AuthContext.Provider value={{ apiBaseUrl, ...auth }}>
      {children}
    </AuthContext.Provider>
  )
}

export function useAuthContext(): AuthContextValue {
  const value = useContext(AuthContext)
  if (!value) {
    throw new Error('useAuthContext must be used inside AuthProvider')
  }

  return value
}
